import React, { useId } from "react";
import { Backdrop, Button, CardActions, CircularProgress, Grid, List, SwipeableDrawer } from "@material-ui/core";

import Tooltip from "@material-ui/core/Tooltip";
import PageTitle from "../../../components/PageTitle/PageTitle.js";
import useStyles from "../../../themes/style.js";
import { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  FormControl,
  InputLabel,
  TextField,
  TextareaAutosize,
  TablePagination,
  Typography,
  Card,
  CardContent,
  CardMedia as CardHeader,
  Chip,
} from "@material-ui/core";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import { useForm, useFieldArray } from "react-hook-form";
import { Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { IoAdd, IoRemove } from "react-icons/io5";
import Switch from "@material-ui/core/Switch";
import { useLocation } from "react-router-dom";
import { useNotification } from "../../../hooks/useNotification.js";
import { makeStyles } from "@material-ui/core/styles";
import { MdEdit } from "react-icons/md";
import { getFileExtension } from "../../../utils/getextension.js";
import CustomPdfView from "../../../components/pdfViewer/CustomPdfView.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import moment from "moment";
import NoDataFound from "../../../components/NoDataFound/index.js";
import CloseIcon from "@material-ui/icons/Close";
import MUIDataTable from "mui-datatables";

const useCardStyles = makeStyles((theme) => ({
  card: {
    maxWidth: 400,
    margin: "auto",
    border: `1px solid ${theme.palette.divider}`,

    boxShadow: theme.shadows[3],
    borderRadius: theme.shape.borderRadius,
  },
  statusChip: {
    marginTop: theme.spacing(1),
    fontWeight: "bold",
    color: theme.palette.common.white,
  },
  reterned: {
    backgroundColor: theme.palette.success.main,
    borderTop: `3px solid ${theme.palette.success.dark}`,
  },
  inPossession: {
    backgroundColor: "#3f51b5",
  },
  root: {
    "& .Mui-disabled": {
      color: "#4caf50 !important", // Success green for disabled
    },
  },
  switchBase: {
    color: "#ff4081", // Thumb color when unchecked (pink)
    "&.Mui-checked": {
      color: "#4caf50", // Thumb color when checked (green)
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      backgroundColor: "#4caf50 !important", // Track color when disabled
    },
  },
  track: {
    backgroundColor: "#bdbdbd", // Track color when unchecked (gray)
    "&.Mui-checked": {
      backgroundColor: "#4caf50", // Track color when checked (green)
    },
    "&.Mui-disabled": {
      backgroundColor: "#9e9e9e", // Track color when disabled (light gray)
    },
  },
}));

const ViewLoan = () => {
  const classes = useStyles();
  const cardClasses = useCardStyles();
  const [currerntPage, setCurrerntPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const token = localStorage.getItem("token");
  const mobileQuery = useMediaQuery("(max-width:600px)");
    const [loanDoument, setLoanDoument] = useState(false);
    const [loanDocumentURL, setLoanDocumentURL] = useState("");
  const location = useLocation();
  const toggleDrawer = (anchor, open) => (event) => {
    setState({ ...state, [anchor]: open });
  };

  const handleLoanDocumentOpen = (url) => {
    setLoanDoument(true);
    setLoanDocumentURL(process.env.REACT_APP_AWS_BUCKET_URL + url);
  };



  const [loanDetails, setLoanDetails] = useState([]);

  const handleNotificationCall = useNotification();

  const queryParams = new URLSearchParams(location.search);
  const [viewLoanDetails, setViewLoanDetails] = useState({});
   const [state, setState] = useState({
      right: false,
    });
    const [count, setCount] = useState(0);

  const userID = queryParams.get("userId");
  console.log(userID);

  function getEmpName(user) {
    let empName;
    if (user?.employee) {
      empName = user.employee.firstName + " " + user.employee.lastName;
    }

    if (user?.recruiter) {
      empName = user.recruiter.firstName + " " + user.recruiter.lastName;
    }
    return empName;
  }

  const handleLoanDocumentClose = () => {
    setLoanDoument(false);
  };



  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoader(true);

    try {
      const viewAlldata = await axios.get(
        `${process.env.REACT_APP_SERVER}loan/viewAllUserLoans?page=${currerntPage}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        },
      );
      if (viewAlldata.data.status) {
        setLoanDetails(viewAlldata.data.data);
        setLoader(false);

        setCount(viewAlldata.data.count);
      } else {
        handleNotificationCall("error", viewAlldata.data.message);
      }
    } catch (error) {
      console.log(error);
      handleNotificationCall("error", "Error Happend!");
    } finally {
      setLoader(false);
    }
  };

  console.log(loanDetails);

  const AssetCard = ({ loanDetails }) => {
    return (
      <Card
        className={cardClasses.card}
        style={{
          borderTop: loanDetails.assetStatus
            ? "3px solid #3f51b5"
            : "3px solid #10B981",
          height: "100%",
          position: "relative",
          marginBottom: "50px",
          paddingBottom: "30px",
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <CardHeader
            title={loanDetails.assetName}
            subheader={loanDetails.assetType}
            titleTypographyProps={{
              variant: "h4",
              color: "primary",
              style: { fontSize: "20px", fontWeight: 600 },
            }}
            subheaderTypographyProps={{
              variant: "subtitle1",
              color: "textSecondary",
            }}
          />
        </Box>
        <CardContent>
          <Typography variant="body2" color="textSecondary">
            {loanDetails.assetDescription}
          </Typography>

          <br />

          <div style={{ position: "absolute", bottom: "15px", left: "15px" }}>
            <Typography variant="body2" color="dark">
              <span style={{ color: "#3f51b5" }}>In Possession Date: </span>{" "}
              {`${moment(loanDetails.createdAt).format("DD-MM-YYYY")}`}
              <br />
              {!loanDetails.assetStatus && (
                <>
                  <span style={{ color: "#10B981" }}>Reterned Date:</span>{" "}
                  {moment(loanDetails.givenTime).format("DD-MM-YYYY")}
                </>
              )}
            </Typography>

            <Chip
              label={loanDetails.assetStatus ? "In Possession" : "Reterned"}
              className={`${cardClasses.statusChip}`}
              style={{
                backgroundColor: loanDetails?.assetStatus
                  ? "#3f51b5"
                  : "#10B981",
              }}
            />
          </div>
        </CardContent>
      </Card>
    );
  };

  function handleSidebarView(item, name) {
    // setViewLoanDetailsModal((prev) => !prev);
    setViewLoanDetails(item);
    
    setState({ ...state, right: true });
  }

  const HeaderElements = () => <>Total : {count}</>;

  const list = (anchor) =>(

      <Box sx={{ width: "100%" }} role="presentation">
        <List>
          <Card className={classes.root}>
            <CardHeader>
              <Grid
                container
                direction="row"
                spacing={1}
                className={classes.drawerViewHeader}
              >
                <Grid item xs={10} md={6}>
                  <Typography variant="subtitle1">View Loan Details</Typography>
                </Grid>

                <Grid item xs={2} md={6} className={classes.drawerViewClose}>
                  <CloseIcon
                    className={classes.closeBtn}
                    size="14px"
                    onClick={toggleDrawer(anchor, false)}
                  />
                </Grid>
              </Grid>
            </CardHeader>

            <CardContent className={classes.drawerViewContent}>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>Name</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {getEmpName(viewLoanDetails?.user)}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Email ID:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {viewLoanDetails?.user?.email}
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Principal Amount:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {"₹" + viewLoanDetails.principalAmount}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Amount of Interest:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {"₹" + viewLoanDetails.amountOfInterest}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Interest Rate:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {viewLoanDetails.interestRate + "%"}
                </Grid>

                {viewLoanDetails.reason && (
                  <>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <Typography className={classes.boldtext}>
                        Reason:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      {viewLoanDetails.reason}
                    </Grid>
                  </>
                )}

                {viewLoanDetails.loanDocument && (
                  <>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <Typography className={classes.boldtext}>
                        Loan Document:
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <Tooltip
                        title="View Loan Document"
                        placement="bottom"
                        aria-label="View"
                      >
                        <RemoveRedEyeIcon
                          className={classes.toolIcon}
                          onClick={() =>
                            handleLoanDocumentOpen(viewLoanDetails.loanDocument)
                          }
                        />
                      </Tooltip>
                    </Grid>
                  </>
                )}

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Duration:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {viewLoanDetails.amountOfTime +
                    `${
                      viewLoanDetails.amountOfTime <= 1 ? " Month" : " Months"
                    }`}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Remaining Balance:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {"₹" + viewLoanDetails.remainingBalance}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Amound Paid :
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {"₹" + viewLoanDetails.amountPaid}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>Status</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Button
                    className={
                      viewLoanDetails?.loanStatus === "INPROGRESS"
                        ? classes.yellow
                        : classes.green
                    }
                  >
                    {viewLoanDetails.loanStatus}
                  </Button>
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Paid Dues:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {viewLoanDetails.noOfGivenTime +
                    `${
                      viewLoanDetails.noOfGivenTime <= 1 ? " Month" : " Months"
                    }`}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Remaining Dues:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {viewLoanDetails.remainingTime +
                    `${
                      viewLoanDetails.remainingTime <= 1 ? " Month" : " Months"
                    }`}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Due Amount:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {"₹" + viewLoanDetails.singleTimeAmount}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Posted On:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {moment(viewLoanDetails.createdAt).format("DD-MM-YYYY")}
                </Grid>

                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <Typography className={classes.boldtext}>
                    Modified On:
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {moment(viewLoanDetails.updatedAt).format("DD-MM-YYYY")}
                </Grid>
              </Grid>
            </CardContent>
            <CardActions>
              <Grid
                container
                direction="row"
                spacing={2}
                className={classes.drawerFooter}
              >
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  onClick={toggleDrawer(anchor, false)}
                >
                  Close
                </Button>
              </Grid>
            </CardActions>
          </Card>
        </List>
      </Box>)



       let fileExtension = loanDocumentURL
          ? getFileExtension(loanDocumentURL)
          : null;


  return (
    <>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Loan Details" />
        </Grid>
       
      </Grid>
    

      <MUIDataTable
        title=""
        options={{
          textLabels: {
            body: {
              noMatch: "Oops! Matching record could not be found",
            },
          },
          pagination: false,
          sort: false,
          selectableRows: "none",
          search: false,
          filter: false,
          download: false,
          print: false,
          customToolbar: () => <HeaderElements />,
          responsive: mobileQuery === true ? "vertical" : "standard",
        }}
        columns={[
          {
            name: "S.No",
          },
          {
            name: "Principal Amount",
          },
          {
            name: "Amount Of Interest",
          },
          {
            name: "Duration",
          },
          {
            name: "Remaining Balance",
          },
          {
            name: "Amound Paid",
          },
          {
            name: "Status",
          },
          {
            name: "Action",
          },
        ]}
        data={loanDetails.map((item, index) => {
          return [
            <>
              {currerntPage !== 0
                ? 10 * currerntPage - 10 + index + 1
                : index + 1}
            </>,
            "₹" + item?.principalAmount,
            "₹" + item?.amountOfInterest,
            `${item?.amountOfTime}${
              item?.amountOfTime === 1 ? " Month" : " Months"
            }`,
            "₹" + item?.remainingBalance,
            "₹" + item?.amountPaid,
            <Button
              className={
                item?.loanStatus === "INPROGRESS"
                  ? classes.yellow
                  : classes.green
              }
            >
              {item?.loanStatus === "INPROGRESS" ? "IN PROGRESS" : ""}
            </Button>,
            <div>
              <Tooltip
                key={item.id}
                title="View Loan detail"
                placement="bottom"
                aria-label="view"
              >
                <RemoveRedEyeIcon
                  className={classes.toolIcon}
                  onClick={() => handleSidebarView(item, "VIEW")}
                  style={{ marginRight: "10px" }}
                />
              </Tooltip>

      
            </div>,

           
          ];
        })}
      />

      <Grid item xs={3} sm={5} md={4} lg={6} className={classes.drawerClose}>
        <SwipeableDrawer
          anchor="right"
          open={state["right"]}
          onClose={toggleDrawer("right", false)}
          onOpen={toggleDrawer("right", true)}
          classes={{ paper: classes.drawer }}
        >
          {list("right")}
        </SwipeableDrawer>
      </Grid>

      <Dialog
        aria-labelledby="dialog-title"
        open={loanDoument}
        fullWidth={true}
        maxWidth="md"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogContent>
          <Grid
            container
            direction="row"
            spacing={2}
            style={{ minHeight: "300px" }}
          >
            <div
              className={`${classes.heading} ${classes.inputRoot} ${classes.pdfModalTitleText}`}
            >
              <Typography variant="subtitle2" className={classes.inputRoot}>
                Loan Document
              </Typography>
              <div className={classes.pdfModalCloseBtn}>
                <CloseIcon
                  className={classes.closeBtn}
                  onClick={handleLoanDocumentClose}
                />
              </div>
            </div>
            <Grid item xs={12}>
              {fileExtension === "pdf" ? (
                <CustomPdfView resumeUrl={loanDocumentURL} />
              ) : (
                <div
                  className={classes.iframediv}
                  style={{ marginTop: "40px" }}
                >
                  <iframe
                    src={
                      "https://docs.google.com/a/umd.edu/viewer?url=" +
                      loanDocumentURL +
                      "&embedded=true"
                    }
                    title="File"
                    width="100%"
                    height="500"
                    sandbox="allow-scripts allow-same-origin"
                  ></iframe>
                  <div className={classes.iframeLogo}></div>
                </div>
              )}
            </Grid>
            <div className={classes.sendWhatsapp + " " + classes.inputRoot}>
              <Button
                variant="contained"
                size="small"
                color="secondary"
                onClick={handleLoanDocumentClose}
              >
                Close
              </Button>
            </div>
          </Grid>
        </DialogContent>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default ViewLoan;
